import _capitalize from "lodash/capitalize"
import _map from "lodash/map"
import _split from "lodash/split"
import _join from "lodash/join"

export const capitalizeString = (value) => {
  if (typeof value !== "string") {
    throw new Error("The value must be a string")
  }

  const arrayValue = _map(_split(value, " "), (value) => _capitalize(value))

  return _join(arrayValue, " ")
}



// WEBPACK FOOTER //
// ./src/services/utils/capitalize.js